import { useTranslation } from 'react-i18next'
import LoadingIndicator from '@/widgets/LoadingIndicator'
import CertificationForm from '../common/CertificationForm'
import useCertificationEditPage from './hooks/useCertificationEditPage'

export default function CertificationEdit() {
	const { t } = useTranslation()
	const { certification, handleCancel, handleSubmit, loading, submitting } = useCertificationEditPage()

	if (loading) {
		return <LoadingIndicator message={t('trainingCertifications.edit.loading')} />
	}

	return (
		<div className="max-w-6xl mx-auto px-0 sm:px-6 lg:px-8">
			<div className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl">
				<div className="px-4 sm:px-6 py-6 border-b border-gray-200">
					<h1 className="text-2xl font-bold text-gray-900">{t('trainingCertifications.edit.title')}</h1>
				</div>

				<div className="px-4 sm:px-6 py-6">
						<CertificationForm
							mode="edit"
							initialData={certification}
							onSubmit={handleSubmit}
							onCancel={handleCancel}
							submitting={submitting}
						/>
				</div>
			</div>
		</div>
	)
}
